export class BffEvaluationsClient {
  constructor(evaluationsBackend, authenticationService) {
    this.evaluationsBackend = evaluationsBackend;
    this.authenticationService = authenticationService;
    this.BASE_URL = '/bff/evaluations';
    this.BASE_URL_V11 = '/v1.1/bff/evaluations';
  }

  async getDebtor(idNumber) {
    const url = `${this.BASE_URL_V11}/debtor/${idNumber}`;
    const config = this.defaultAxiosRequestConfig();
    const response = await this.evaluationsBackend.get(url, config);
    return response.data;
  }

  async getSimulation(evaluationId, type = 'automatic') {
    const url = `${this.BASE_URL_V11}/simulation/${evaluationId}?type=${type}`;
    const config = this.defaultAxiosRequestConfig();
    const response = await this.evaluationsBackend.get(url, config);
    return response.data;
  }

  async getEvaluations(idNumber) {
    const url = `${this.BASE_URL}/list?idNumber=${idNumber}`;
    const config = this.defaultAxiosRequestConfig();
    const response = await this.evaluationsBackend.get(url, config);
    return response.data;
  }

  async getGeneral(evaluationId) {
    const url = `${this.BASE_URL}/general?evaluationId=${evaluationId}`;
    const config = this.defaultAxiosRequestConfig();
    const response = await this.evaluationsBackend.get(url, config);
    return response.data;
  }

  async setRatify(evaluationId) {
    const url = `/v1.0/evaluation/ratify/${evaluationId}`;
    const config = this.defaultAxiosRequestConfig();
    const response = await this.evaluationsBackend.post(url, {}, config);
    return response.data;
  }

  async addFileToEvaluations(clientId, idNumber, evaluationId, files) {
    const url = `${this.BASE_URL}/debtor/${idNumber}/files/${clientId}`;

    const config = this.defaultAxiosRequestConfig();
    config.headers['Content-Type'] = 'multipart/form-data';
    config.timeout = 120000;

    const data = files;
    data.evaluationId = evaluationId;
    const response = await this.evaluationsBackend.patch(url, data, config);
    return response.data;
  }

  async getEvaluationsParamsByIdNumber(idNumber) {
    const url = `${this.BASE_URL}/params?idNumber=${idNumber}`;

    const config = this.defaultAxiosRequestConfig();
    const response = await this.evaluationsBackend.get(url, config);
    return response.data;
  }

  async getEvidence(evaluationId) {
    const url = `${this.BASE_URL}/evidence/${evaluationId}`;
    const config = this.defaultAxiosRequestConfig();
    const response = await this.evaluationsBackend.get(url, config);
    return response.data;
  }

  defaultAxiosRequestConfig() {
    return {
      headers: this.authenticationService.authHeader()
    };
  }
}
